import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  schemaData?: object;
}

const SEO: React.FC<SEOProps> = ({
  title = "Yeremian Lifestyle Homes - YLH - Premier Georgia Home Builders | Custom Homes",
  description = "Yeremian Lifestyle Homes (YLH) - Premier custom home builders in Georgia. Building quality homes in Rome, Dawsonville, and North Georgia with 2-10 warranty protection. 15+ years experience.",
  keywords = "Yeremian Lifestyle Homes, YLH, Georgia home builders, custom homes Georgia, Rome GA homes, Dawsonville GA homes, North Georgia builders, new construction homes, home builders near me, quality home construction, 2-10 warranty homes",
  image = "https://yeremianlifestylehomes.com/og-image.png",
  url = "https://yeremianlifestylehomes.com",
  type = "website",
  schemaData
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Yeremian Lifestyle Homes" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Schema.org structured data */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO; 